// src/app/core/services/version.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface BackendVersion {
  version: string;
  timestamp: string;
}

@Injectable({ providedIn: 'root' })
export class VersionService {
  private static VERSION_URL = `${environment.apiUrl}/version`;

  constructor(private http: HttpClient) {}

  getBackendVersion(): Observable<BackendVersion> {
    return this.http.get<BackendVersion>(VersionService.VERSION_URL);
  }
}
